import Login from './Login';
import Register from './signup/Register';

export { Login, Register };
